import { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'

import ImgHandshake from 'assets/icons/img-handshake.svg'

interface DialogSignSKPProps extends Omit<DialogProps, 'children'> {
  isLoading?: boolean
  isDeleteSKPEnabled?: boolean
  onClickConfirm?: () => any
  onClickCancel?: () => any
}

const DialogSignSKP = ({
  isLoading,
  isDeleteSKPEnabled = false,
  onClickConfirm = () => {},
  onClickCancel = () => {},
  ...props
}: DialogSignSKPProps) => {
  const [isChecked, setIsChecked] = useState(false)

  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent>
        <DialogCloseButton data-testid="btn-close" />
        <div className="mt-12 p-6">
          <ImgHandshake width={84} height={84} />
          <Text variant="display-sm" className="mt-4">
            {isDeleteSKPEnabled
              ? 'Setelah disepakati, Perencanaan Kinerja tidak dapat diubah lagi'
              : 'Sepakati Perencanaan Kinerja?'}
          </Text>
          <Text color="subdued" className="mt-4 !text-xl">
            {isDeleteSKPEnabled
              ? 'Pastikan Anda dan atasan sudah diskusi dan sepakat dengan perencanaan ini. Jika ada yang ingin diubah, Anda dapat ulang perencanaan dari awal.'
              : 'Dengan menyepakati, Anda akan lanjut ke Pelaksanaan Kinerja.'}
          </Text>

          <div className="mt-4">
            <Checkbox
              checked={isChecked}
              disabled={isLoading}
              onChange={(e) => setIsChecked(e.target.checked)}
            >
              Saya sepakat dengan Perencanaan Kinerja yang disetujui oleh
              atasan.
            </Checkbox>
          </div>

          <div className="flex gap-5 mt-5">
            <Button
              size="lg"
              className="w-[190px]"
              disabled={isLoading || !isChecked}
              isLoading={isLoading}
              onClick={() => onClickConfirm()}
              data-testid="btn-confirm"
            >
              Sepakat
            </Button>
            <Button
              size="lg"
              color="white"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={() => onClickCancel()}
              data-testid="btn-cancel"
            >
              {isDeleteSKPEnabled ? 'Ulangi dari awal' : 'Cek ulang'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogSignSKP
